﻿import {styled} from "@mui/material/styles";
import {Typography, TypographyOwnProps} from "@mui/material";
import {Theme} from "@mui/system";

type OriginalTypographyProps = TypographyOwnProps & {
  isRevised?: boolean;
}

type RootType = OriginalTypographyProps & {
  theme: Theme;
}

export const Root = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isRevised'
})(({theme, isRevised}: RootType) => (isRevised && {
  backgroundColor: theme.palette.error.main,
  color: "white",
  paddingLeft: "5px",
  margin: "0 10px 0-5px",
  borderRadius: "4px",
}));

const OriginalTypography = (props: OriginalTypographyProps) => {
  return <Root variant="subtitle2" {...props} />
}

export default OriginalTypography;
